// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"802e874f","366":"fbd06064","453":"886bc5a1"}[chunkId] + ".chunk.js";
};